type MessageOptions = {
  vendorName?: string | null;
  branchName?: string | null;
  branchCode?: string | null;
  companyDisplayName?: string | null;
  syncKind?: "branch" | "purchase_history" | null;
};

function formatBranchLabel(branchName?: string | null, branchCode?: string | null): string | null {
  const name = branchName?.trim();
  const code = branchCode?.trim();
  if (name && code) return `${name} (${code})`;
  return name || code || null;
}

/** User-facing catalog sync copy with vendor + branch when available. */
export function heritageCatalogSyncMessage({
  vendorName,
  branchName,
  branchCode,
  companyDisplayName,
  syncKind = "branch",
}: MessageOptions): string {
  const vendor = vendorName?.trim();
  const branchLabel = formatBranchLabel(branchName, branchCode);
  const action =
    syncKind === "purchase_history"
      ? "Heritage purchase history catalog download in progress"
      : "Heritage branch catalog download in progress";

  if (vendor && branchLabel) {
    return `${action} for vendor ${vendor}, branch ${branchLabel} — will take at least a few minutes to complete.`;
  }
  if (vendor) {
    return `${action} for vendor ${vendor} — will take at least a few minutes to complete.`;
  }

  const company = companyDisplayName?.trim() || "your company";
  if (syncKind === "purchase_history") {
    return `${action} for ${company} — will take at least a few minutes to complete.`;
  }
  if (branchLabel) {
    return `${action} for ${company}, branch ${branchLabel} — will take at least a few minutes to complete.`;
  }
  return `${action} for ${company} — will take at least a few minutes to complete.`;
}

/** Shorter label for toolbar badges. */
export function heritageCatalogSyncShortLabel({
  vendorName,
  branchName,
  branchCode,
  syncKind = "branch",
}: MessageOptions): string {
  const vendor = vendorName?.trim();
  const branchLabel = formatBranchLabel(branchName, branchCode);
  const prefix =
    syncKind === "purchase_history"
      ? "Purchase history sync in progress"
      : "Catalog sync in progress";

  if (vendor && branchLabel) {
    return `${prefix} — ${vendor} · ${branchLabel}`;
  }
  if (vendor) {
    return `${prefix} — ${vendor}`;
  }
  if (branchLabel) {
    return `${prefix} — ${branchLabel}`;
  }
  return syncKind === "purchase_history"
    ? "Purchase history sync in progress..."
    : "Catalog sync in progress...";
}

export function resolveHeritageBranchDetails(
  branchId: number | null | undefined,
  settings?: { branch_name?: string | null; branch_code?: string | null } | null,
  branches?: { id: number; branch_name?: string | null; branch_code?: string | null }[]
): { branchName: string | null; branchCode: string | null } {
  const fromList = branchId != null ? branches?.find((b) => b.id === branchId) : undefined;
  return {
    branchName: settings?.branch_name ?? fromList?.branch_name ?? null,
    branchCode: settings?.branch_code ?? fromList?.branch_code ?? null,
  };
}
